import { render, staticRenderFns } from "./CharacterTab.vue?vue&type=template&id=722cf9c4"
import script from "./CharacterTab.vue?vue&type=script&lang=js"
export * from "./CharacterTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports